import React, { memo } from 'react';
import { Text, View } from 'react-native';
import { useWidgetStyles } from './styles';

const WIDGET_LOADING_LABELS: Record<string, string> = {
  chart: '生成图表中',
  bi_visualization: '生成图表中',
  suggested_questions: '',
};

export const WidgetLoadingPlaceholder = memo(({ tag }: { tag?: string }) => {
  const s = useWidgetStyles();
  const label = WIDGET_LOADING_LABELS[tag ?? ''];
  if (label === '') return null;
  return (
    <View style={s.loading}>
      <Text style={s.loadingText}>{label ?? '加载中'}...</Text>
    </View>
  );
});
